var _defs, _path, _polygon, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilettesBonnePosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "r\\xE9paration_toilettes",
    "data-name": "r\\xE9paration toilettes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 777.62 534.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "toilettes bonne r\xE9ponse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983.76,1315.31V1198.18c-89-7.48-108.74-59-109.61-122.51h228.9v-245H1253.5v484.66Z",
    transform: "translate(-475.88 -790.19)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "609.98 287.63 609.98 52.28 627.17 81.65 627.17 286.55 609.98 287.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521,1315c-37,7-37.8-53-8-53,0,0,165-10,188-13-21,2-165.07,14.7-192.8,1.91s-51.74-66.18,6.43-132.9L659,927.49c52.41-45.42,99.72,22.8,137.5,53.76l168.56,111.9c17.34,19.22,5.64,49.41-19.1,46.32L739.84,1037.56S605.46,1158.54,610,1169c18.72-2.28,130.51,10.92,178,45,14.69,10.54,5.66,79.44-16,89C696.19,1336.48,521,1315,521,1315Z",
    transform: "translate(-475.88 -790.19)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 327.32,
    cy: 79.02,
    r: 79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilettesBonnePosition);
export default __webpack_public_path__ + "static/media/toilettes_bonne_position.f1cdaffc395cc33e1523582a4b75acf0.svg";
export { ForwardRef as ReactComponent };